import React from "react";
import {
  Box,
  Heading,
  OrderedList,
  ListItem,
  Text,
} from "@chakra-ui/react";
import { Trans, useTranslation } from "next-i18next";
import checkIfFullFridge from "@/utils/fullFridge";
import CustomHead from "@/components/common/CustomHead";

const PrivacyPolicy = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      <CustomHead title={t("profileSettings.privacyPolicy")}/>
      <Box
        p={{ base: "30px 15px", sm: "50px", xl: "100px" }}
        textAlign="justify"
      >
        <Heading
          size="lg"
          variant="simple"
          fontSize={{ base: "23px", sm: "35px" }}
          textAlign="center"
        >
          {t("privacyPolicy")}
        </Heading>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 1<br/>
          {t("privacyPolicyPage.article1Title")}
        </Heading>
        <OrderedList>
          <ListItem>
            {checkIfFullFridge() ?
              <Trans i18nKey="privacyPolicyPage.article1Paragraph1FF">
                Niniejszy dokument określa Politykę Prywatności Serwisu <b>www.fullfridge.app</b> i Aplikacji dostępnej na marketach Google Play i Apple Store pod nazwą <b>Full Fridge</b> oraz wydawcy, <b>Copernicus Apps Sp. z o.o.</b> z siedzibą w Białych Błotach (86-005) ul. Betonowa 1/24, Wpisana przez Sąd Rejonowy w Bydgoszczy, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod Nr KRS 0000992078, która w szczególności obejmuje regulacje dotyczące ochrony danych osobowych oraz bezpieczeństwa innych danych wprowadzonych do Aplikacji przez Użytkownika.
              </Trans>          
            :
              <Trans i18nKey="privacyPolicyPage.article1Paragraph1">
                Niniejszy dokument określa Politykę Prywatności Serwisu <b>www.garazowewyprzedaze.pl</b> i Aplikacji dostępnej na marketach Google Play i Apple Store pod nazwą <b>Garażowe Wyprzedaże</b> oraz wydawcy, <b>Copernicus Apps Sp. z o.o.</b> z siedzibą w Białych Błotach (86-005) ul. Betonowa 1/24, Wpisana przez Sąd Rejonowy w Bydgoszczy, XIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod Nr KRS 0000992078, która w szczególności obejmuje regulacje dotyczące ochrony danych osobowych oraz bezpieczeństwa innych danych wprowadzonych do Aplikacji przez Użytkownika.
              </Trans>
            }
          </ListItem>
          <ListItem>{t("privacyPolicyPage.article1Paragraph2")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 2<br/>
          {t("privacyPolicyPage.article2Title")}
        </Heading>
        <Text my={3}>
          {t("privacyPolicyPage.article2Text1")}
        </Text>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article2Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article2Paragraph2")}</ListItem>
          <ListItem>{checkIfFullFridge() ? t("privacyPolicyPage.article2Paragraph3FF") : t("privacyPolicyPage.article2Paragraph3")}</ListItem>
          <ListItem>{checkIfFullFridge() ? t("privacyPolicyPage.article2Paragraph4FF") : t("privacyPolicyPage.article2Paragraph4")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article2Paragraph5")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article2Paragraph6")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 3<br/>
          {t("privacyPolicyPage.article3Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article3Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article3Paragraph2")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article3Paragraph3")}</ListItem>
          <OrderedList listStyleType="lower-alpha">
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item1")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item2")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item3")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item4")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item5")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item6")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item7")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item8")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph3Item9")}</ListItem>
          </OrderedList>
          <ListItem>{t("privacyPolicyPage.article3Paragraph4")}</ListItem>
          <OrderedList listStyleType="lower-alpha">
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item1")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item2")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item3")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item4")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item5")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item6")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item7")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item8")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article3Paragraph4Item9")}</ListItem>
          </OrderedList>
          <ListItem>{t("privacyPolicyPage.article3Paragraph5")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 4<br/>
          {t("privacyPolicyPage.article4Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article4Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph2")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph3")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph4")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph5")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph6")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph7")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph8")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article4Paragraph9")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 5<br/>
          {t("privacyPolicyPage.article5Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article5Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article5Paragraph2")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 6<br/>
          {t("privacyPolicyPage.article6Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article6Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article6Paragraph2")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article6Paragraph3")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article6Paragraph4")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 7<br/>
          {t("privacyPolicyPage.article7Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article7Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article7Paragraph2")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article7Paragraph3")}</ListItem>
          <OrderedList listStyleType="lower-alpha">
            <ListItem>{t("privacyPolicyPage.article7Paragraph3Item1")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article7Paragraph3Item2")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article7Paragraph3Item3")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article7Paragraph3Item4")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article7Paragraph3Item5")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article7Paragraph3Item6")}</ListItem>
          </OrderedList>
          <ListItem>{t("privacyPolicyPage.article7Paragraph4")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article7Paragraph5")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 8<br/>
          {t("privacyPolicyPage.article8Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article8Paragraph1")}</ListItem>
          <OrderedList listStyleType="lower-alpha">
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item1")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item2")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item3")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item4")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item5")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item6")}</ListItem>
            <ListItem>{t("privacyPolicyPage.article8Paragraph1Item7")}</ListItem>
          </OrderedList>
          <ListItem>{t("privacyPolicyPage.article8Paragraph2")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article8Paragraph3")}</ListItem>
        </OrderedList>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 9<br/>
          {t("privacyPolicyPage.article9Title")}
        </Heading>
        <Text my={3}>{t("privacyPolicyPage.article9Text1")}</Text>
        <Heading
          size="md"
          fontSize={{ base: "18px", sm: "20px" }}
          textAlign="center"
        >
          § 10<br/>
          {t("privacyPolicyPage.article10Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("privacyPolicyPage.article10Paragraph1")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article10Paragraph2")}</ListItem>
          <ListItem>{t("privacyPolicyPage.article10Paragraph3")}</ListItem>
        </OrderedList>
      </Box>
    </>
  );
};

export default PrivacyPolicy;
